// AYA PRO Phase 1 — helpers d'espace (localStorage).
export const SPACE_KEY = "aya_space";
export const PRO_PROFILE_KEY = "aya_pro_profile";

export function getSpace() {
  try { return localStorage.getItem(SPACE_KEY); } catch { return null; }
}
export function setSpace(v) {
  try { localStorage.setItem(SPACE_KEY, v); } catch { /* private mode */ }
}
export function getProProfile() {
  try { return localStorage.getItem(PRO_PROFILE_KEY) || "commercant"; } catch { return "commercant"; }
}
export function setProProfile(v) {
  try { localStorage.setItem(PRO_PROFILE_KEY, v); } catch { /* private mode */ }
}

export const PROFILE_META = {
  commercant: { label: "Commerçant", icon: "🛍️" },
  business: { label: "Business", icon: "💼" },
  entreprise: { label: "Entreprise", icon: "🏢" },
  municipalite: { label: "Municipalité", icon: "🏛️" },
};
